import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'
import roundedCheck from 'assets/icons/roundedCheck.svg'
import VoucherPartialPaid from './VoucherPartialPaid'
import { useMemo } from 'react'
import { useAppSelector } from 'store/hooks'
import Loader from 'components/shared/Loader'

interface CodeValidProps {
    voucherCode?: string
    isLoading?: boolean
    isCartFetching?: boolean
    isSelfcareCartFetching?: boolean
}

const VoucherValid = ({
    voucherCode,
    isLoading,
    isCartFetching,
    isSelfcareCartFetching,
}: CodeValidProps) => {
    const { remainingCardValue: remainingSelfcareCardValue } = useAppSelector(
        (state) => state.selfcareCart
    )
    const { cart } = useAppSelector((state) => state.cart)
    const { remainingCardValue, payOnlinePrice } = cart || {}

    const voucherContent = useMemo(() => {
        if (
            remainingCardValue !== undefined &&
            remainingCardValue === 0 &&
            payOnlinePrice !== undefined &&
            payOnlinePrice > 0
        ) {
            return <VoucherPartialPaid voucherCode={voucherCode ?? ''} />
        }

        if (
            remainingSelfcareCardValue !== undefined &&
            remainingSelfcareCardValue === 0 &&
            payOnlinePrice !== undefined &&
            payOnlinePrice > 0
        ) {
            return <VoucherPartialPaid voucherCode={voucherCode ?? ''} />
        }

        return (
            <FormattedMessage
                id="vouchers.discount.application_confirmation"
                defaultMessage="Zastosowano voucher <voucher></voucher>"
                values={{
                    voucher: () => (
                        <>
                            {!!voucherCode && (
                                <Text
                                    as="span"
                                    variant="bodyStrong"
                                    color="success"
                                >
                                    {` ${voucherCode}`}
                                </Text>
                            )}
                        </>
                    ),
                }}
            />
        )
    }, [voucherCode, remainingCardValue, remainingSelfcareCardValue])

    return (
        <Box direction="row" gap={8}>
            {isLoading || isCartFetching || isSelfcareCartFetching ? (
                <Loader />
            ) : (
                <>
                    <img src={roundedCheck} alt="rounded green checkmark" />
                    <Text variant="bodyStrong" color="success">
                        {voucherContent}
                    </Text>
                </>
            )}
        </Box>
    )
}

export default VoucherValid
